import React from "react";
import {Link, useHistory} from "react-router-dom";
import CustomHistory from "../../CustomHistory";


const handleUrl = (url) => () => CustomHistory.push(url);

const AppDotLink = (props) => {
  // const history = useHistory();
  const {imgWidth, leftFactor, topFactor, url, onClick, external} = props;

  const getLeftPoint = () => {
    return imgWidth * leftFactor + 'px';
  };
  const getTopPoint = () => {
    return imgWidth * topFactor + 'px';
  };
  if (!external)
  {
    return (
      <div
        className="dot wave-animation"
        style={{
          left: getLeftPoint(),
          top: getTopPoint()
        }}
        onClick={url ? handleUrl(url) : onClick}
      />
    )
  }
  else {
    return (
      <div
        className="dot wave-animation"
        onClick={()=> window.open(url, "_blank")}
        style={{
          left: getLeftPoint(),
          top: getTopPoint()
        }}
      />
    )
  }
}

export default AppDotLink;